import React, { Component } from 'react';
import { Row, Col, Button, Card, CardBody, CardTitle, CardSubtitle, CardText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButonDisabled } from './ButonDisabled';
import { translate } from 'react-jhipster';
/* eslint-disable no-console */
export const Finish = props => {
  console.warn(Object.keys(props.selectedFeature));

  const handleClickBack = e => {
    props.handleClickBack();
  };

  const selectedColor = 'primary';
  console.log(props.selectedFeature);
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginBottom: 32 }}>
        <ButonDisabled
          style={{
            backgroundColor: '#e62333',
            color: '#fff',
            borderRadius: 999,
            padding: '10px 26px',
            fontWeight: 600,
            border: 'none',
            boxShadow: '0 8px 24px rgba(230,35,51,.35)',
          }}
          onClick={props.finishEvent}
          disabled={false}
        >
          <i className="fas fa-check mr-2" />
          {translate('entity.action.ok')}
        </ButonDisabled>

        <ButonDisabled
          style={{
            backgroundColor: '#fff',
            color: '#e62333',
            borderRadius: 999,
            padding: '10px 26px',
            fontWeight: 600,
            border: '2px solid #e62333',
          }}
          onClick={handleClickBack}
          disabled={false}
        >
          <i className="fas fa-arrow-left mr-2" />
          {translate('entity.action.back')}
        </ButonDisabled>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
        }}
      >
        {Object.keys(props.selectedFeature).map(element =>
          props.selectedFeature[element].price > 0 ? (
            <Card
              key={element}
              className={`feature-card ${
                props.selectedFeature[element].price === props.allFeature[props.selectedFeature[element].currentid].selectPositivePrice
                  ? 'selected'
                  : ''
              }`}
            >
              <CardBody>
                <CardTitle tag="h5" className="feature-title">
                  {translate('project.wizard.duration')}:{' '}
                  <span>
                    {props.selectedFeature[element].feature === undefined
                      ? props.allFeature[props.selectedFeature[element].currentid].duration
                      : props.selectedFeature[element].feature.map(feature => feature.duration).reduce((a, b) => a + b, 0)}
                  </span>
                </CardTitle>

                <CardSubtitle tag="h6" className="feature-subtitle">
                  {translate('project.wizard.' + props.allFeature[props.selectedFeature[element].currentid].datalang)}
                </CardSubtitle>

                {props.selectedFeature[element].feature && (
                  <CardText className="feature-list">
                    {props.selectedFeature[element].feature.map(feature => feature.element).join(', ')}
                  </CardText>
                )}

                <div className="feature-price">
                  {translate('project.wizard.totalprice')}: <strong>${props.selectedFeature[element].price}</strong>
                </div>
              </CardBody>
            </Card>
          ) : null
        )}
      </div>

      {/* </Row> */}
    </div>
  );
};

export default Finish;
